//chapter1
export default {
    id : 3,//chapter number
    title : '03. 몰드 공정(Molding) (3)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/03/videos/a03.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '트랜스퍼 몰딩',
                '컴프레션 몰딩',
                '탑게이트 몰딩',
            ],
            body2 : [
                '트랜스퍼 몰딩에 대해 설명할 수 있다.',
                '컴프레션 몰딩에 대해 설명할 수 있다.',
                '탑게이트 몰딩에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/03/videos/03.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '트랜스퍼 몰딩 방법이 패키지의 두께를 줄이는데 유리한 방법이다.',//html available
                    answer : "2",
                    explain : '트랜스퍼 몰딩보다는 컴프레션 몰딩 공정이 패키지 두께를 줄이는데 유리한 방법이다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '컴프레션 몰딩은 패키지 두께가 변경될 때 마다 금형을 새로 만들어야 한다.',//html available
                    answer : "2",
                    explain : '컴프레션 몰딩방법은 패키지 두께가 어느 정도 변경되어도 몰딩이 가능하다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>트랜스퍼 몰딩<br>
                        - 두께고정 type(Mold 부분), 두께 고정 type(PCB 부분)<br>
                        - backing plate에 따라서 미세하게 조정가능<br>
                        - 일반적으로 적용하는 몰딩 방법</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>컴프레션 몰딩<br>
                        - 두께 상관 없음(PCB 부분)<br>
                        - 0.2T~0.9T까지 한 금형으로 사용 가능하며 design 변경 시 0.9T 이상 가능(Mold 부분)<br>
                        - 대면적 기판 몰딩 시 진행</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>탑게이트 몰딩<br>
                        - PCB의 중심으로부터 몰딩 진행<br>
                        - PoP 제품 구현을 위한 몰딩 진행</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/03/videos/a03.mp4',
        },
    ]
}